import { Box } from '@mui/joy';
import { useTheme } from '@mui/joy/styles';
import { CustomCellRendererProps } from 'ag-grid-react';

import { DEFAULT_DETAIL_ROW_HEIGHT } from 'core/constants';
import { PartList } from 'jobs/components/JobDetails';
import { IJob } from 'jobs/types';

interface IProps extends CustomCellRendererProps {
  job: IJob;
}

export const DetailElement = ({ data, job }: IProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        padding: 1.5,
        height: DEFAULT_DETAIL_ROW_HEIGHT,
        backgroundColor: theme.palette.background.level1,
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '100%',
          padding: '12px',
          backgroundColor: theme.palette.background.body,
          borderRadius: 6,
        }}
      >
        <PartList job={job} element={data} />
      </Box>
    </Box>
  );
};
